import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';
import '@fortawesome/fontawesome-free/css/all.css';
import 'flag-icons/css/flag-icons.min.css';
import { getLanguageCode, messages } from './language';
import { initializeKeycloak } from './keycloak';
import App from './views/App.vue';
import router from './router';

// Always initialize and mount the Vue app
const i18n = createI18n({
  locale: getLanguageCode(),
  fallbackLocale: 'en',
  messages,
});

initializeKeycloak().then(() => {
  const app = createApp(App);
  app.use(router);
  app.use(i18n);
  app.mount('#app');
}).catch(error => {
  console.error(`Keycloak initialization failed: ${error}`);
  alert(this.$t('main.failed_to_init'));
});

